exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea.fieldWithErrors,input.fieldWithErrors, .x-window input.x-form-invalid {\n    border-color: #f00!important;\n}\n.dropdown-toggle::after {\n\tdisplay:none;\n}\n.pro-img img {\n    width: 150px;\n    height: 150px;\n    display: block;\n\tmargin: 0 auto;\n    -o-object-fit: cover;\n       object-fit: cover;\n    border-radius: 100%;\n}\n.profile-img-bg {\n    margin-bottom: 20px;\n}\n.pro-img-btn {\n    margin-top: 20px;\n}\n.pro-img {\n    text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /workspace/backend-server/src/app/user/registration/registration.component.css
// module id = ../../../../../src/app/user/registration/registration.component.css
// module chunks = main